export default "__VITE_ASSET__9ac02c3b__"